// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const counter_VARIANTS = ["%(counter)s variant", "%(counter)s varianty", "%(counter)s variantov"];
export const ESHOP_URL = "shop.modrykonik.com";
export const FROM_WIDGET = "od";
export const SHOPPING_WITH_MK = "Nakupuj s kon\u00edkom";
